import PropTypes from "prop-types";
import React, {useState, useEffect, useRef} from "react";
import {withRouter} from "react-router-dom";
import {withStyles} from "@material-ui/core";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import styles from "./styles";
import {Header, Main, Sidebar} from "./partials";
import {Wrapper} from "../index";
import {loadDistrictDataBuyId} from "../../store/district";
import classNames from "classnames";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const Poi = ({classes, match, pois}) => {
	const {poi} = match.params;
	const item = pois[poi];
	const topRef = useRef();
	const bottomRef = useRef();
	const [displayDownButton, setDisplayDownButton] = useState(true);
	const [displayUpButton, setDisplayUpButton] = useState(false);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
	}, []);

	const handleScroll = () => {
		if (window.pageYOffset > window.innerHeight - 60) {
			setDisplayDownButton(false);
			setDisplayUpButton(true);
		} else {
			setDisplayDownButton(true);
			setDisplayUpButton(false);
		}
	};

	const handleScrollToBottom = () => {
		bottomRef.current.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	};

	const handleScrollToTop = () => {
		topRef.current.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	};
	return (
		<>
			<div ref={topRef}/>
			<Header className={classes.header}/>
			<div className={classes.wrapper}>
				<Main className={classes.main} poi={item}/>
				{/* <Sidebar className={classes.sidebar} poi={item}/> */}
			</div>
			<div ref={bottomRef}/>
			<div className={classNames(classes.scrollDown)}>
				{displayDownButton && (
					<ExpandMoreIcon
						className={classes.colorWhite}
						onClick={handleScrollToBottom}
					/>
				)}
				{displayUpButton && (
					<ExpandLessIcon
						className={classes.colorWhite}
						onClick={handleScrollToTop}
					/>
				)}
			</div>
		</>
	);
};

const mapStateToProps = state => ({
	pois: state.pois[state.helpers.building],
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

Poi.propTypes = {
	classes: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired,
	pois: PropTypes.object.isRequired,
};

export default withRouter(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Poi)),
);
